@if (appName === 'investigator-portal') {
<main class="investigator-auth w-full h-screen">
  <div class="investigator-form-shell">
    <router-outlet></router-outlet>
  </div>
</main>
} @else {
<div class="flex flex-col lg:flex-row w-full h-screen">
  <!--begin::Form-->
  <div
    class="flex justify-center items-center w-full lg:w-1/2 p-4 bg-light-primary order-2 lg:order-1"
  >
    <!--begin::Wrapper-->
    <div class="w-full h-full" style="max-width: 400px">
      <router-outlet></router-outlet>
    </div>
    <!--end::Wrapper-->
  </div>
  <!--end::Form-->

  <!--begin::Aside-->
  <div
    class="flex justify-center items-center w-full lg:w-1/2 bg-img order-1 lg:order-2"
  >
    <div
      class="flex flex-col justify-center items-center py-15 px-5 lg:px-15 w-full"
    >
      <a routerLink="/">
        @if(appName==='investigator-portal'){
        <img
          class="img-fluid investigator-aside-logo"
          alt="Coreact Investigator Portal"
          src="assets/media/logos/coreact-investigator-portal.png"
        />
        }@else if(appName==='coassess'){
        <img
          class="img-fluid"
          alt="Logo"
          src="assets/coassess-logo-light.png"
        />
        }@else {
        <img
          class="img-fluid"
          alt="Logo"
          src="assets/images/coreact-logo-light.png"
        />
        }
      </a>
    </div>
  </div>
  <!--end::Aside-->
</div>
}
